// extracted by mini-css-extract-plugin
export default {"refund":"RefundPolicy_refund__rQHiE","refund__content":"RefundPolicy_refund__content__f-R6V"};